/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { DialogDefaultV2, InputV2 } from '../../../components/v2';

const InvalidarDialog = ({ open, onClose, onConfirm }) => {
  const [motivo, setMotivo] = useState('');
  const [motivoError, setMotivoError] = useState(false);

  useEffect(() => {
    if (open) {
      setMotivo('');
      setMotivoError(false);
    }
  }, [open]);

  const handleConfirm = () => {
    if (!motivo || !motivo.trim()) {
      setMotivoError(true);
      return;
    }
    onConfirm(motivo.trim());
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onClose}
      handlerConfirm={handleConfirm}
      title="Invalidar hora extra"
      confirmMessage="Confirmar"
      cancelMessage="Cancelar"
      maxWidth="sm"
      fullWidth
      useFullScreen={false}
    >
      <Grid container spacing={1}>
        <Grid size={{ xs: 12 }}>
          <InputV2
            label="Motivo"
            value={motivo}
            onChange={(e) => {
              setMotivo(e.target.value);
              if (e.target.value && e.target.value.trim()) setMotivoError(false);
            }}
            multiline
            rows={3}
            isRequired
            error={motivoError}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

InvalidarDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default InvalidarDialog;
